// BeneficiaryCard.js
import React from 'react';
import propTypes from 'prop-types';
import { Card } from '../../Atoms';
import { Col } from 'react-bootstrap';

const BeneficiaryCard = ({ beneficiary, index, totalBeneficiaries, onSelect }) => {
  const isFirstBeneficiary = index === 0;
  const columnSize =
    (index + 1) % 3 === 2 && totalBeneficiaries === index + 1 ? 12 : 6;

  return (
    <Col
      className="new-container-card-profile scale-up-center"
      md={4}
      xs={columnSize}
    >
      <Card
        text={beneficiary.name}
        size="medium"
        disabled={isFirstBeneficiary}
        onClick={() => !isFirstBeneficiary && onSelect(beneficiary.value, index)}
      />
    </Col>
  );
};

BeneficiaryCard.propTypes = {
  beneficiary: propTypes.shape({
    name: propTypes.string.isRequired,
    value: propTypes.any.isRequired,
  }).isRequired,
  index: propTypes.number.isRequired,
  totalBeneficiaries: propTypes.number.isRequired,
  onSelect: propTypes.func.isRequired,
};

export default BeneficiaryCard;
